import { cn } from '@/utils/cn'

export interface BadgeProps {
  text: string
  color?: 'orange' | 'blue' | 'green' | 'purple' | 'gray'
  size?: 'sm' | 'md' | 'lg'
  variant?: 'solid' | 'outline' | 'subtle'
  className?: string
}

export function Badge({
  text,
  color = 'orange',
  size = 'md',
  variant = 'solid',
  className,
}: BadgeProps): HTMLElement {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300'

  const sizes = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-3 py-1',
    lg: 'text-sm px-4 py-1.5',
  }

  const solidVariants = {
    orange: 'bg-orange-600 text-white',
    blue: 'bg-blue-600 text-white',
    green: 'bg-green-600 text-white',
    purple: 'bg-purple-600 text-white',
    gray: 'bg-slate-600 text-white',
  }

  const outlineVariants = {
    orange: 'bg-transparent border-2 border-orange-600 text-orange-600',
    blue: 'bg-transparent border-2 border-blue-600 text-blue-600',
    green: 'bg-transparent border-2 border-green-600 text-green-600',
    purple: 'bg-transparent border-2 border-purple-600 text-purple-600',
    gray: 'bg-transparent border-2 border-slate-600 text-slate-600',
  }

  const subtleVariants = {
    orange: 'bg-orange-100 text-orange-600',
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    gray: 'bg-slate-100 text-slate-600',
  }

  let variantClasses = ''
  if (variant === 'solid') {
    variantClasses = solidVariants[color]
  } else if (variant === 'outline') {
    variantClasses = outlineVariants[color]
  } else if (variant === 'subtle') {
    variantClasses = subtleVariants[color]
  }

  const badge = document.createElement('span')
  badge.className = cn(
    baseStyles,
    sizes[size],
    variantClasses,
    className
  )
  badge.textContent = text

  return badge
}
